/* eslint-disable react/forbid-prop-types,react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableHead, TableRow
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import SkeletonTable from 'components/Skeletons/SkeletonTable/SkeletonTable';
import useMobile from 'hook/UseMobile';
import PropTypes from 'prop-types';
import { MOBILE_BREAKPOINT } from 'utils/constants/responsive';
import CustomIcon from 'commons/Icon/CustomIcon';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';

const CELL_STYLE = { maxWidth: '30vw', overflowX: 'overlay', overflowY: 'hidden' };

const useStyles = makeStyles((theme) => ({
  white: {
    backgroundColor: theme.palette.background.paper
  },
  rowStriped: {
    '&:nth-child(even)': {
      backgroundColor: theme.palette.primary.light
    },
    '& > td': {
      [theme.breakpoints.down('sm')]: {
        padding: '2px 10px 2px 10px'
      }
    }
  },
  hoverRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary.tableHover
    }
  },
  tableHeader: {
    ...CELL_STYLE,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      padding: '3px 12px 3px 12px'
    },
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      padding: '1px 8px 1px 8px'
    }
  },
  tableCell: {
    ...CELL_STYLE
  },
  overflowHidden: {
    overflow: 'hidden'
  },
  bold: {
    fontWeight: 'bold'
  }
}));

export const ResponsibilitiesTable = ({
  rows, headers, onRowCLick, stickyHeader, isLoading, onChange, total
}) => {
  const classes = useStyles();
  const isMobile = useMobile();
  const theme = useTheme();

  useEffect(() => {
    onChange();
  }, [total]);

  const finalHeaders = isMobile
    ? headers.filter((header) => header.isOnMobile)
    : headers;

  return (
    <>
      {isLoading
        ?
        <Table
          className={classes.white}
          size="small"
          stickyHeader={stickyHeader}
        >
          <SkeletonTable columns={finalHeaders.length} rows={10} />
        </Table>
        :
        <Table
          className={classes.white}
          size="small"
          stickyHeader={stickyHeader}
        >
          <TableHead>
            <TableRow>
              {finalHeaders.map((header) => (
                <TableCell
                  align={header.align}
                  className={`${classes.white} ${classes.tableHeader}`}
                  key={header.name} width={isMobile ? header.mobileWidth : header.width}
                >
                  <LocalizedText text={header.label} />{header.displayInfo &&
                     <CustomIcon
                       color={theme.palette.primary.main}
                       icon={faCircleInfo}
                       size="lg"
                       style={{marginLeft: '5px'}}
                       tooltip={header.infoText}
                     />
                  }
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0
              ? (
                <TableRow>
                  <TableCell colSpan={finalHeaders.length}>
                    <LocalizedText align="center" variant="h6">noDataInTable</LocalizedText>
                  </TableCell>
                </TableRow>
              )
              : rows.map((row) => (
                <TableRow
                  className={`${classes.rowStriped} ${onRowCLick ? classes.hoverRow : ''}`}
                  key={row.id}
                  onClick={() => onRowCLick && onRowCLick(row)}
                >
                  {finalHeaders.map((column) => (
                    <TableCell
                      align={column.align}
                      className={`${classes.tableCell} ${column.bold ? classes.bold : ''}`}
                      key={column.name}
                      width={isMobile ? column.mobileWidth : column.width}
                    >
                      {column.template(row)}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      }
    </>
  );
};

ResponsibilitiesTable.propTypes = {
  filters: PropTypes.object,
  headers: PropTypes.arrayOf(PropTypes.shape({
    isOnMobile: PropTypes.bool,
    isSortable: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    sortOn: PropTypes.string,
    template: PropTypes.func
  })).isRequired,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func,
  onRowCLick: PropTypes.func,
  rowKey: PropTypes.string,
  rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  stickyHeader: PropTypes.bool,
  total: PropTypes.number
};

ResponsibilitiesTable.defaultProps = {
  filters: {},
  isLoading: false,
  onChange: () => {},
  onRowCLick: null,
  rowKey: null,
  stickyHeader: false,
  total: null
};